export default {
  computed: {
    bookmark() {
      return this.$store.getters['bookmarks/get'][`Flashcard-${this.flashcardId}`];
    },
    hasBookmark() {
      return !!(this.bookmark && !this.bookmark.deleted);
    },
  },
  methods: {
    createBookmark() {
      const contextId = this.simId || this.categoryId;
      if (!contextId) {
        console.error('No contextId found for bookmark, skipping bookmark creation');
        return;
      }
      const params = {
        bookmarkableId: this.flashcardId,
        bookmarkableType: 'Flashcard',
        contextId,
        contextType: 'Category',
        mobileCreatedAt: Date.now(),
        deleted: false,
      };
      this.$store.dispatch('bookmarks/createBookmark', params);
      this.sendAnalytics(true);
    },
    toggleBookmark() {
      if (this.bookmark) {
        this.updateBookmark();
      } else {
        this.createBookmark();
      }
    },
    updateBookmark() {
      if (!this.bookmark.contextId) {
        console.error('No contextId found for bookmark, this bookmark will not appear in the saved list. This data should be fixed soon.');
      }
      const params = {
        id: this.bookmark.id,
        deleted: !this.bookmark.deleted,
      };
      this.$store.dispatch('bookmarks/updateBookmark', params);
      this.sendAnalytics(!params.deleted);
    },
    sendAnalytics(flagged) {
      if (this.simulation) {
        const params = {
          simulation: this.simulation,
          section: this.section,
          flashcard: this.flashcard,
          flagged: flagged,
        };
        this.$analytics.events.simulationFlaggedQuestion(params);
        return;
      }

      if (this.categoryId) {
        const params = {
          category: this.category,
          flashcard: this.flashcard,
          bookmarked: flagged,
        };
        this.$analytics.events.flashcardBookmarked(params);
      }
    },
  },
};
